// src/Popup.js
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faXmark} from '@fortawesome/free-solid-svg-icons';
import { SiDoordash } from "react-icons/si";
import Popup1 from '../img/1.png';
// import Popup2 from '../img/2024/9.png';
// import Popup4 from "../img/popup4.png";
// import Popup5 from "../img/popup5.png";

const Popup = (props) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const images = [Popup1];
    
    const handleButtonClick = () => {
        if (currentImageIndex < images.length - 1) {
            setCurrentImageIndex(currentImageIndex + 1);
        } else {
            props.setIsOpen(!props.isOpen);
        }
    };

    return (
		<div onClick={handleButtonClick} className={`${props.isOpen? "opacity-100" : "hidden" } px-2 fixed left-0 top-0 inset-0 z-50 flex h-screen w-screen items-center justify-center bg-black bg-opacity-50`}>
			<div className='relative lg:w-max w-full mx-2'>
                <div className=' lg:w-[500px] rounded-lg space-y-1 w-full bg-white p-6'>
                    <div className=' font-txt-font text-black text-2xl'>
                        <h1>Place Your Order</h1>
                    </div>
                    <hr></hr>
                    <div className=' flex flex-col items-center justify-center'>
                        <div>
                            <button onClick={() => 
                                    window.open("tel:9255168880" , '__blank')
                                } className="hover:shadow-lg font-txt-font text-white lg:text-black border-2 bg-main-color lg:bg-white border-main-color hover:bg-main-color hover:-translate-y-2 hover:bg-main2 hover:text-white ease-in-out delay-100 duration-150 mt-5 flex justify-center items-center space-x-2 md:text-xl text-lg py-2 w-[220px] group cursor-pointer md:tracking-wide">
                                <FontAwesomeIcon className=' text-xl group-hover:text-green-300 lg:text-green-400' icon={faPhone} />
                                <span className="">Call Us</span>
                            </button>
                        </div>

                        <div>
                            <button onClick={() => 
                                    window.open("https://www.doordash.com/store/90166?utm_source=mx_share" , '__blank')
                                } className="hover:shadow-lg font-txt-font text-white lg:text-black border-2 bg-main-color lg:bg-white border-main-color hover:bg-main-color hover:-translate-y-2 hover:bg-main2 hover:text-white ease-in-out delay-100 duration-150 mt-5 flex justify-center items-center space-x-2 md:text-xl text-lg py-2 w-[220px] group cursor-pointer md:tracking-wide">
                                <SiDoordash className=" text-3xl group-hover:text-white lg:text-main-color" />
                                <span className="">DoorDash</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className=' absolute top-1 right-2'>
                    <button className = "  p-2" onClick={handleButtonClick}>
                        <FontAwesomeIcon className=' text-2xl text-main-color' icon={faXmark} />
                    </button>
                </div>
            </div>
		</div>
    );
};

export default Popup;